export const RegexName = /^[A-zÀ-ÿ']+\s([A-zÀ-ÿ.']\s?)*[A-zÀ-ÿ.'][A-zÀ-ÿ']+$/
const RegexEmail = /^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i
const RegexPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,80}$/

const RegexPrefixUrl = /^[a-z]+$/
const RegexWebhookPath = /^[a-zA-Z]+(-[a-zA-Z]+)*$/

const RegexNumber = /^[0-9]+$/

export const validateName = (data: string) => RegexName.test(data)

export const validateEmail = (data: string) => RegexEmail.test(data)

export const validatePassword = (data: string) => RegexPassword.test(data)

export const passwordsMatch = (passwordConfirm: string, password: string) => passwordConfirm === password

export const validatePrefixUrl = (data: string) => RegexPrefixUrl.test(data)

export const validateWebhookPath = (data: string) => RegexWebhookPath.test(data)

export const validateNumber = (data: string) => RegexNumber.test(data)
